var runtime = require("../../../../../../build/webpack-environments/loaders/styles/myCssLoader/runtime.js");
module.exports = {"purchaseIcon":"_2iMDe"};
module.exports._getCss = function(wrap, process){return ""+wrap+" ._2iMDe{border:1px solid #fff;height:25px;width:25px;display:flex;border-radius:50%;justify-content:center;align-items:center;font-size:13px}" };
module.exports._meta = {moduleId: module.id, order: runtime.getOrder()};

